import VolumeSlider from './VolumeSlider';

export default VolumeSlider;
